export default __webpack_public_path__ + "static/media/Brigand's Belt of the Howling Moon.c2df66a5.jpg";